import { render, staticRenderFns } from "./drawer-set-sub-account-pwd.vue?vue&type=template&id=0e8c08fa&"
import script from "./drawer-set-sub-account-pwd.vue?vue&type=script&lang=ts&"
export * from "./drawer-set-sub-account-pwd.vue?vue&type=script&lang=ts&"
import style0 from "./drawer-set-sub-account-pwd.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports